const WebStorageKey = {
  API_ROOT: 'apiRoot',
  CACHE_KEY_LIST_SETTING: 'list_setting',
  IMPORT_API_ROOT: 'importApiRoot',
  RETURN_AFTER_LOGIN: 'returnAfterLogin',
  USER: 'user',
  USER_SETTINGS: 'userSettings',
  TRANSACTION_EDIT_SETTINGS: 'transactionEditSettings',
  INVITATION: 'invitationToken',
  READ_ONLY_CONFIRMED: 'readOnlyConfirmed',
  DANGLING_SUBSCRIPTION_LATER: 'danglingSubscriptionLater',
  NO_ROLE_ASSIGNED_CONFIRMED: 'noRoleAssignedConfirmed',
  SHOP_ERROR: 'shopError',
  IS_LOCKED_CONFIRMED: 'isLockedConfirmed',
  APM_ACTIVE: 'aa',
  APM_LOG_LEVEL: 'all',
  APM_DISABLED_INSTRUMENTATION: 'adi',
  HIDE_X_INVOICE_MODAL: 'hideXInvoiceModal',
  OVERRIDE_MOBILE_WARNING: 'overrideMobileWarning',
  SHOPPING_CART: 'shoppingCart',
  OPEN_DASHBOARD_CLIENT_INVITATIONS: 'openDashboardClientInvitations',
}

export default Object.freeze(WebStorageKey)
